import {OrderDetailsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/sections.types';
import {useTranslation} from '@aboutyou/i18n';
import {COLORS, Text, tabletAndUpLinaria} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {DeliveryOverview} from './DeliveryOverview';
import {OrderConfirmation} from './OrderConfirmation';
import {PriceSection} from './PriceSection';

export const OrderDetails: React.FC<OrderDetailsSection> = props => {
  const {t} = useTranslation();

  return (
    <OrderDetailsStreamWrapper data-testid="ospOrderdetailsSection">
      <SectionHeadline size="px24" weight="mediumHeavy">
        {t('Your order details')}
      </SectionHeadline>
      <OrderConfirmation {...props} />
      <DeliveryOverview packages={props.packages} />
      <PriceSection
        priceRows={props.priceRows}
        total={props.total}
        legalText={props.legalText}
        coinsEarning={props.coinsEarning}
      />
    </OrderDetailsStreamWrapper>
  );
};

const SectionHeadline = styled(Text)`
  // only there on desktop, we will use the order information headline as headline on mweb
  display: none;

  ${tabletAndUpLinaria(`
    display: block;
  `)}
`;

export const OrderDetailsStreamWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: ${COLORS.White};

  ${tabletAndUpLinaria(`
     gap: 1.5rem;
     padding: 2rem 0 1.5rem 0;
  `)}
`;
